export const scrollToTop = (ref: React.RefObject<HTMLDivElement>) => {
  if (ref.current) {
    ref.current.scrollTo({ top: 0, behavior: "smooth" });
  }
};
